var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"anonymous-short",attrs:{"to":{ name: 'PatrimonialLandscape' }}},[(_vm.isAnonymous)?[_vm._v("\n\t\t\tAccès anonyme - Accéder à votre profil et renseignez votre Paysage Patrimonial\n\t\t")]:[_vm._v("\n\t\t\tAccéder à votre profil et renseignez votre Paysage Patrimonial\n\t\t")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f260d44","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoEstateShort.vue
// module id = null
// module chunks = 